import { createContext } from 'react'
import { RxDocument, RxState } from 'rxdb'

import { ApplicationAuthState } from '@/system/rxdb/replication.ts'
import { AppUser } from '@/system/rxdb/schemas/appUser.ts'

export const AuthStateContext =
  createContext<RxState<ApplicationAuthState> | null>(null)

export const UserContext = createContext<{
  user?: RxDocument<AppUser>
  loading: boolean
  logout: () => Promise<void>
}>({ user: undefined, loading: true, logout: () => Promise.resolve() })
